module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.values.length === 0) ? _c('div', {
    staticClass: "form-inline"
  }, [_vm._v("\n    Select number of options to add:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionsCount),
      expression: "optionsCount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": 2
    },
    domProps: {
      "value": (_vm.optionsCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.optionsCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn right green",
    attrs: {
      "disabled": !_vm.optionsCount || _vm.optionsCount < 2
    },
    on: {
      "click": function($event) {
        return _vm.setOptionsCount(_vm.optionsCount)
      }
    }
  }, [_vm._v("\n      Add Options\n    ")]), _vm._v(" "), (_vm.showTemplates) ? _c('button', {
    staticClass: "btn right green",
    on: {
      "click": function($event) {
        return _vm.showAddFromTemplate()
      }
    }
  }, [_vm._v("\n      Choose from template\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.values.length > 0) ? _c('div', [_c('label', [_vm._v("Values")]), _vm._v(" "), _c('draggable', {
    staticClass: "list-group",
    attrs: {
      "tag": "ul",
      "list": _vm.values,
      "handle": '.list-group-item',
      "group": {
        name: 'options',
        pull: false
      }
    }
  }, _vm._l((_vm.values), function(option, index) {
    return _c('li', {
      key: 'rating-item' + index,
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "row no-margin-bot"
    }, [_c('div', {
      staticClass: "input-field",
      class: {
        'col-md-10': !_vm.editValue,
        'col-md-5': _vm.editValue
      }
    }, [_c('label', {
      staticClass: "active",
      attrs: {
        "for": _vm.id + '-option-label-' + index
      }
    }, [_vm._v("Label")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.label),
        expression: "option.label"
      }],
      staticClass: "form-control",
      attrs: {
        "id": _vm.id + '-option-label-' + index,
        "type": "text"
      },
      domProps: {
        "value": (option.label)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(option, "label", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.editValue) ? _c('div', {
      staticClass: "col-md-5 input-field"
    }, [_c('label', {
      staticClass: "active",
      attrs: {
        "for": _vm.id + '-option-value-' + index
      }
    }, [_vm._v("Value")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (option.value),
        expression: "option.value"
      }],
      staticClass: "form-control",
      attrs: {
        "id": _vm.id + '-option-value-' + index,
        "type": "text"
      },
      domProps: {
        "value": (option.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(option, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.values.length > 2) ? _c('div', {
      staticClass: "middle"
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeOption(_vm.values, index)
        }
      }
    })]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    staticClass: "btn right green",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addOption(_vm.values)
      }
    }
  }, [_vm._v("Add Option")]), _vm._v(" "), (_vm.showTemplates) ? _c('button', {
    staticClass: "btn right green",
    on: {
      "click": function($event) {
        return _vm.showAddFromTemplate()
      }
    }
  }, [_vm._v("\n          Choose from template\n        ")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (_vm.showTemplates) ? _c('select-field-template-modal', {
    attrs: {
      "id": _vm.modalId
    },
    on: {
      "confirmed": _vm.addFromTemplate
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-157fc6cf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/EditorOptionsList.vue
// module id = 1563
// module chunks = 1